export function formatValue(value) {
    const cleanedValue = value?.replace(/[^\d]/g, '')
    return parseFloat(cleanedValue)
}
export function formatValuePoint(value) {
    const cleanedValue = value?.replace(/[^\d]/g, '')
    return parseFloat(cleanedValue)
}
